<template>
	<div>
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName">
				<Input type="text" style="width: 180px;" v-model="formInline.ConnectorNo" :placeholder="this.$t('ConnectorNo')">
				<span slot="prepend">{{ this.$t('ConnectorNo') }}</span>
				</Input>
			</FormItem>
			<FormItem prop="trackName" :label="this.$t('Maintenance.AlarmType')" :label-width="100">
				<Select :placeholder="this.$t('Maintenance.AlarmType')" style="width: 120px;" v-model="formInline.AlarmCode">
					<Option :value="-1">{{ this.$t('Common.All') }}</Option>
					<Option v-bind:key="item.Id" v-for="(item) in AlarmDefineList" :value="item.Id">
						{{item.Name}}
					</Option>
				</Select>
			</FormItem>
			
			<FormItem :label="this.$t('Time')" :label-width='70'>
				<DatePicker style="width: 210px;" type="daterange" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeRange" @on-change="handleChange"></DatePicker>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">{{ $t('Common.Search') }}</Button>
			</FormItem>
		</Form>
		<Table :row-class-name="rowClassName" :columns="columns1" :data="data1" :height="tableHeight"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getAlarmRecordUrl" @listData='getDeviceData'></MyPage>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import { formatLocalTime } from "../../../utils/date"
	import Qs from 'qs'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js'
	export default {
		data() {
			return {
				getAlarmRecordUrl: webapi.base_api_url + '/Maintenance/GetAlarmRecord',
				loadingStatus: false,
				//
				params: "", //
				tableHeight: "650",
				
				BreadcrumbList: [this.$t('Top.alarmRrecord'), '>>', this.$t('alarmRrecord')],
				AlarmDefineList: [],
				formInline: {
					StationId: 0,
					ConnectorNo: '',
					TimeBegin: dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24), 'yyyy-MM-dd'),
					TimeEnd: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					TimeRange: [new Date(new Date().getTime() - 1000 * 60 * 60 * 24), new Date()],
				},
				//Table Title Data
				columns1: [{
						title: this.$t('Number'),
						type: 'index',
						width: 80
					},{
						title: this.$t('Maintenance.OccurredTime'),
						key: 'OccurredTime',
						minWidth: 180,
						render: (h, params) => {
							return h('div', formatLocalTime(params.row.OccurredTime))
						}
					}, {
						title: this.$t('Maintenance.AlarmCode'),
						key: 'AlarmCode',
						minWidth: 100,
						render: (h, params) => h('div', params.row.AlarmCode + '-' + params.row.AlarmDesc)
					},
					{
						title: this.$t('Maintenance.AlarmLevel'),
						key: 'AlarmLevel',
						minWidth: 120,
						render: (h, params) => h('div', params.row.AlarmLevel == 1 ? '1-人身安全级' : params.row.AlarmLevel == 2 ?
							'2-设备安全级' : '3-告警提示级'),
					},
					// {
					// 	title: '告警详情',
					// 	key: 'AlarmDesc'
					// },
					{
						title: this.$t('Maintenance.AlarmStatus'),
						key: 'Status',
						minWidth: 90,
						render:(h,params)=>  h('div',params.row.Status + '-' + params.row.StatusDesc),
						// render:(h,params)=>{
						// 	return h('div',params.row.StatusDesc)
						// }
					},
					// {
					// 	title: '告警状态描述',
					// 	key: 'StatusDesc'
					// },
					{
						title: this.$t('ConnectorNo'),
						key: 'ConnectorNo',
						minWidth: 120,
					},
					{
						title: this.$t('EquipmentNo'),
						key: 'EquipmentNo',
						minWidth: 120,
					},
					{
						title: this.$t('Station'),
						key: 'StationName',
						minWidth: 120,
					}, {
						title: this.$t('Remark'),
						key: 'Remark',
						minWidth: 100,
					}
				],
				data1: [],
			};
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 220;
			this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight)
		},
		updated() {},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSubmit();
			this.getAlarmDefineList();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = _this.formInline;
				return param
			},
		
			...mapState({
				StationList: 'Stations'
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleChange(date, type) {
				console.log("Date change：", date, type);
				this.formInline.TimeBegin = date[0];
				this.formInline.TimeEnd = date[1];
			},
			rowClassName: function(row, index) {
				if (index % 2 == 0) {
					return 'demo-table-info-row';
				} else if (index % 2 == 1) {
					return 'demo-table-error-row';
				}
				return '';
			},
			
			show: function(type, params) {},
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 190;
			},
			getAlarmDefineList: function() {
				this.axios.post(webapi.base_api_url + '/Common/GetAlarmDefineList').then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						this.AlarmDefineList = res.data.Data.List;
					}
				})
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}
</style>
